import { Check, ChevronsUpDown } from 'lucide-react';
import { useListOrganizations, useSetActiveOrganization } from '@/api/organizations/queries';
import { useGetSubscription } from '@/api/subscription/queries';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';

export const OrganizationSelect = () => {
  const { data: organizations } = useListOrganizations();
  const { data: subscription } = useGetSubscription();
  const { mutate: setActiveOrganization } = useSetActiveOrganization();

  const handleOrganizationChange = (organizationId: string) => {
    setActiveOrganization({ organizationId });
  };

  const activeOrganization = organizations?.find(
    ({ id }) => id === subscription?.activeOrganizationId,
  );

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground justify-center border border-input"
            >
              <div className="grid flex-1 text-left text-sm leading-tight [[data-state=collapsed]_&]:hidden">
                <span className="text-xs text-muted-foreground">Organization</span>

                <span className="truncate font-medium">{activeOrganization?.name}</span>
              </div>
              <ChevronsUpDown className="[[data-state=expanded]_&]:ml-auto" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
            align="start"
            side="bottom"
            sideOffset={4}
          >
            <DropdownMenuLabel className="text-muted-foreground text-xs">
              Switch organization
            </DropdownMenuLabel>
            {organizations?.map((organization) => (
              <DropdownMenuItem
                key={organization.id}
                className="gap-2 p-2"
                onClick={() => handleOrganizationChange(organization.id)}
              >
                {organization.name}{' '}
                {organization.id === subscription?.activeOrganizationId && (
                  <Check className="ml-auto" />
                )}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
